<template>
  <div class="loanSupeermarketBox">
    <!-- swipe 部分 -->
    <div class="swipe">
      <my-swipe ref="swipeRef"></my-swipe>
    </div>
    <!-- 外部跳转 -->
    <div class="outLink">
      <out-link ref="outLinkRef"></out-link>
    </div>
    <!-- 产品详情的 -->
    <div class="productList">
      <product-list
        ref="productListRef"
        @changeShowModal="changeShowModal"
      ></product-list>
    </div>
    <div class="footer">
      <footers></footers>
    </div>
    <!-- 服务地址的modal层 -->
    <div class="addressModal">
      <address-modal
        ref="addressModalRef"
        v-if="showModal"
        v-on:closeme="closeme"
        :address="address"
        :districtId="districtId"
      ></address-modal>
    </div>
    <FloatingWindow></FloatingWindow>
  </div>
</template>
<script>
import FloatingWindow from '@/components/FloatingWindow.vue';
import MySwipe from './components/MySwipe.vue';
import OutLink from './components/OutLink.vue';
import ProductList from './components/ProductList.vue';
import AddressModal from './components/AddressModal.vue';
import Footers from './components/Footers.vue';
import bus from './utils/bus';

export default {
  name: 'loanSupermarket',
  data() {
    return {
      showModal: false,
      address: '',
      districtId: '',
    };
  },
  created() {
  },
  mounted() {
    bus.$on('showModal', (value) => {
      this.showModal = value;
    });
    bus.$on('getAddressObject', (data) => {
      this.address = data.address;
      this.districtId = data.districtId;
    });
  },
  components: {
    MySwipe,
    OutLink,
    ProductList,
    AddressModal,
    Footers,
    FloatingWindow,
  },
  methods: {
    closeme() {
      this.showModal = false;
    },
    changeShowModal(flag) {
      this.showModal = flag;
    },
  },
};
</script>
<style lang="scss" scoped></style>
